import React, { Component } from 'react';
import { RootState } from '../../../../../redux/store';
import { ConfigurationState } from '../../../../../redux/reducers/ConfigurationReducer';
import { changeConfiguration } from '../../../../../redux/actions/ConfigurationActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { TransactionJsonModel } from '../../../../../domain/stream/transaction/TransactionDomains';
import { FieldData, SuspiciousActivityReport } from '../../../../../domain/case/SuspiciousActivityReport';
import Icon from '../../../../../icons/Icon';
import ValueUtil from '../../../../../util/ValueUtil';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from '../../../../custom/FormicaSearchSelectBox';
import FormicaToggleSwitch from '../../../../custom/FormicaToggleSwitch';
import {
  AciliyetEnum,
  BelgeTuruEnum,
  BildirimKategoriEnum,
  CinsiyetEnum,
  DigerKisiIslemBaglantisiEnum,
  GercekKisiIslemBaglantisiEnum,
  HesapTuruEnum,
  IletisimEnum,
  IslemCesidiEnum,
  IslemDurumuEnum,
  IslemeAracilikEtmeDurumuEnum,
  IslemKanaliEnum,
  IslemTuruEnum,
  KimlikTespitTuruEnum,
  KisitlamaTuruEnum,
  KurulusNeviEnum,
  MeslekEnum,
  ParaBirimiEnum,
  SupheKategorileriEnum,
  SupheninTespitEdildigiBirimEnum,
  TerorOrgutuEnum,
} from '../../../../../constant/SarConstants';
import CustomInput from '../../../../custom/CustomInput';
import LanguageUtil from '../../../../../util/LanguageUtil';
import { Tooltip } from 'primereact/tooltip';
import SarFieldInfoButton from '../../../../sar/SarFieldInfoModalComponent';

class DomainConfigurationSuspiciousActivityReportComponent extends Component<Props, State> {
  public state: State = new State();

  public render() {
    const {
      configuration: { configuration },
    } = this.props;
    const data: SuspiciousActivityReport = configuration.suspiciousActivityReport;
    return (
      <div className={'flex w-full h-full p-5 !max-h-[calc(100vh-16rem)] scrollable-editor-container overflow-y-scroll'}>
        <div className='w-1/2 px-5 border-r border-b-[#E0E4E8] overflow-y-scroll'>{this.renderFieldsLeftRecursive(data)}</div>
        <div className='w-1/2 px-5 overflow-y-scroll'>{this.renderFieldsRightSide(data)}</div>
      </div>
    );
  }

  private renderFieldsLeftRecursive = (data: any, path: string[] = []) => {
    const rightSideKeys = ['gercekKisi', 'digerKisi'];
    return (
      <div className='flex flex-col'>
        {Object.keys(data)
          .sort(this.customSortFunction)
          .map((key) => {
            const currentPath = [...path, key];
            return (
              <div key={key}>
                {rightSideKeys.includes(key) ? null : (
                  <>
                    {this.renderField(key, data[key], currentPath)}
                    {typeof data[key].value === 'object' && (
                      <div style={{ marginLeft: '20px' }}>{this.renderFieldsLeftRecursive(data[key].value, currentPath)}</div>
                    )}
                  </>
                )}
              </div>
            );
          })}
      </div>
    );
  };

  private renderFieldsRightSide = (data: any) => {
    const rightSideKeys = ['gercekKisi', 'digerKisi'];
    return (
      <div className='flex flex-col'>
        {rightSideKeys.map((key) => (
          <div key={key}>
            {this.renderField(key, data[key], [key])}
            {typeof data[key].value === 'object' && <div style={{ marginLeft: '20px' }}>{this.renderFieldsLeftRecursive(data[key].value, [key])}</div>}
          </div>
        ))}
      </div>
    );
  };

  private renderField = (fieldKey: string, fieldData: FieldData, path: string[]) => {
    const { label, value, type, staticVisible, staticValue, additionalInfo } = fieldData;
    return (
      <div key={fieldKey} className={'flex justify-between py-3 border-b border-b-[#E0E4E8]'}>
        <div className={'flex items-center gap-x-2'}>
          <Icon size={16} icon={typeof value === 'object' ? 'arrow1' : 'arrow2'} color={'#607080'} />
          <div className={'flex flex-col'}>
            
            {/* TODO: Update and Add this */}

            {/* <div className='flex items-center gap-x-2'>
              <label className={'text-f-black-2 text-xs font-normal'}>{ValueUtil.convertEnumToString(type)}</label>
              <SarFieldInfoButton
                fieldPath={path.join('.')}
                fieldLabel={label}
                fieldType={ValueUtil.convertEnumToString(type)}
                additionalInfo={additionalInfo}
                trigger={<Icon size={12} icon={'info'} className='cursor-pointer text-f-black-2 hover:text-f-gray-3 transition-all duration-300' />}
              />
            </div> */}
            <label className={'text-f-black-2 text-xs font-normal'}>{ValueUtil.convertEnumToString(type)}</label>

            <label className={'text-f-black-2 text-md font-medium'}>{label}</label>
          </div>
        </div>
        {typeof value !== 'object' && (
          <div className={'flex items-center gap-x-2'}>
            {staticVisible ? (
              this.getStaticField(fieldKey, staticValue, path)
            ) : (
              <FormicaSearchSelectBox
                value={value}
                placeholder={LanguageUtil.get({ id: 'common.input.placeholder.empty', defaultMessage: 'Empty' })}
                ghost
                rounded
                onChange={(selectedValue) => this.handleChange(path, selectedValue.value, 'select')}
                options={this.getTransactionVariables()}
              />
            )}
            <FormicaToggleSwitch value={staticVisible || false} large={false} onChange={() => this.handleChange(path, !staticVisible, 'toggle')} />
          </div>
        )}
      </div>
    );
  };

  private renderSelectBox = (fieldKey: string, staticValue: string | undefined, path: string[]) => {
    return (
      <FormicaSearchSelectBox
        value={staticValue || ''}
        placeholder={LanguageUtil.get({ id: 'common.input.placeholder.empty', defaultMessage: 'Empty' })}
        ghost
        rounded
        onChange={(selectedValue) => this.handleChange(path, selectedValue.value, 'static')}
        options={this.getStaticFieldOptions(fieldKey, path)}
      />
    );
  };

  private renderInputField = (staticValue: string | undefined, path: string[]) => {
    return (
      <CustomInput
        className={'min-w-[170px] text-f-black-3 h-[30px]'}
        inputType={'ghost'}
        placeholder={LanguageUtil.get({ id: 'common.input.placeholder.empty', defaultMessage: 'Empty' })}
        onChange={(e) => this.handleChange(path, e.currentTarget.value, 'static')}
        value={staticValue || ''}
      />
    );
  };

  private getStaticField = (fieldKey: string, staticValue: string | undefined, path: string[]) => {
    const selectBoxFields = [
      'bildirimKategorisi',
      'aciliyet',
      'terorOrgutu',
      'islemCesidi',
      'islemDurumu',
      'paraBirimi',
      'islemTuru',
      'islemKanali',
      'isleminTetiklendigiYer',
      'islemeAracilikEtmeDurumu',
      'hesapTuru',
      'kisitlamaTuru',
      'supheKategorisi',
      'islemleBaglantisi',
      'cinsiyeti',
      'belgeTuru',
      'meslek',
      'iletisimBilgisi',
      'kimlikBilgileriSahte',
      'kimlikTespitTuruTip',
      'kurulusNevi',
      'magdur',
    ];
    if (selectBoxFields.includes(fieldKey)) {
      return this.renderSelectBox(fieldKey, staticValue, path);
    } else {
      return this.renderInputField(staticValue, path);
    }
  };

  private getStaticFieldOptions = (fieldKey: string, path: string[]) => {
    const getEnumOptions = (enumObject: Record<string, string>): FormicaSelectBoxItem[] =>
      Object.entries(enumObject).map(([key, value]) => ({ label: value as string, value: key }));
    switch (fieldKey) {
      case 'bildirimKategorisi':
        return getEnumOptions(BildirimKategoriEnum);
      case 'aciliyet':
        return getEnumOptions(AciliyetEnum);
      case 'terorOrgutu':
        return getEnumOptions(TerorOrgutuEnum);
      case 'islemCesidi':
        return getEnumOptions(IslemCesidiEnum);
      case 'islemDurumu':
        return getEnumOptions(IslemDurumuEnum);
      case 'paraBirimi':
        return getEnumOptions(ParaBirimiEnum);
      case 'islemTuru':
        return getEnumOptions(IslemTuruEnum);
      case 'islemKanali':
        return getEnumOptions(IslemKanaliEnum);
      case 'isleminTetiklendigiYer':
        return getEnumOptions(SupheninTespitEdildigiBirimEnum);
      case 'hesapTuru':
        return getEnumOptions(HesapTuruEnum);
      case 'kisitlamaTuru':
        return getEnumOptions(KisitlamaTuruEnum);
      case 'supheKategorisi':
        return getEnumOptions(SupheKategorileriEnum);
      case 'islemleBaglantisi':
        const isGercekKisi = path[0] === 'gercekKisi';
        return getEnumOptions(isGercekKisi ? GercekKisiIslemBaglantisiEnum : DigerKisiIslemBaglantisiEnum);
      case 'cinsiyeti':
        return getEnumOptions(CinsiyetEnum);
      case 'belgeTuru':
        return getEnumOptions(BelgeTuruEnum);
      case 'meslek':
        return getEnumOptions(MeslekEnum);
      case 'iletisimBilgisi':
        return getEnumOptions(IletisimEnum);
      case 'magdur':
        return [
          { label: LanguageUtil.get({ id: 'common.label.victim', defaultMessage: 'Victim' }), value: 'E' }, // Mağdur
          { label: LanguageUtil.get({ id: 'common.label.notVictim', defaultMessage: 'Not Victim' }), value: 'H' },
        ];
      case 'kimlikBilgileriSahte':
        return [
          { label: LanguageUtil.get({ id: 'common.label.fraud', defaultMessage: 'Fraud' }), value: 'E' }, // Sahte
          { label: LanguageUtil.get({ id: 'common.label.notFraud', defaultMessage: 'Not Fraud' }), value: 'H' },
        ];
      case 'kimlikTespitTuruTip':
        return getEnumOptions(KimlikTespitTuruEnum);
      case 'kurulusNevi':
        return getEnumOptions(KurulusNeviEnum);
      case 'islemeAracilikEtmeDurumu':
        return getEnumOptions(IslemeAracilikEtmeDurumuEnum);
      default:
        return [];
    }
  };

  private handleChange = (path: string[], newValue: any, type: 'input' | 'select' | 'static' | 'toggle') => {
    const {
      configuration: { configuration },
      changeConfiguration,
    } = this.props;
    let newData = { ...configuration };

    const updateNestedObject = (data: any, keys: string[], value: any): any => {
      const key = keys[0];
      if (keys.length === 1) {
        if (type === 'static') {
          data[key].staticValue = value;
        } else if (type === 'toggle') {
          data[key].staticVisible = value;
        } else {
          data[key].value = value;
        }
      } else {
        data[key].value = updateNestedObject(data[key].value, keys.slice(1), value);
      }
      return data;
    };

    newData.suspiciousActivityReport = updateNestedObject(newData.suspiciousActivityReport, path, newValue);
    changeConfiguration(newData);
  };

  private getTransactionVariables = (): FormicaSelectBoxItem[] => {
    const {
      configuration: { eventItems, configuration },
    } = this.props;
    if (configuration.dataSource == undefined) return [];
    const options = eventItems
      .find((event) => event.name == configuration.dataSource)
      ?.variables.map((value) => ({
        label: value.description && value.description.length > 0 ? value.description : value.name,
        value: value.name,
      }));
    return [{ label: LanguageUtil.get({ id: 'common.label.empty', defaultMessage: 'Empty' }), value: '' }, ...(options || [])];
  };

  private customSortFunction = (a: any, b: any) => {
    const priorityOrder = [
      'yukumlu',
      'temelBilgi',
      'bildirimKategorisi',
      'yerelReferansNo',
      'oncekiBildirimReferansNo',
      'aciliyett',
      'terorOrgutu',
      'supheliIslem',
      'islemCesidi',
      'islemTarihi1',
      'islemTarihi2',
      'islemDurumu',
      'hesabaBagli',
      'tutarTP',
      'tutar',
      'paraBirimi',
      'islemTuru',
      'islemKanali',
      'ipv4',
      'port',
      'islemAciklamasi',
      'ulkeKodu',
      'ilKodu',
      'ilceKodu',
      'isleminGerceklestigiYer',
      'isleminTetiklendigiYer',
      'islemeAracilikEtmeDurumu',
      'islemeAracilikEdenKurum',
      'hesap',
      'sahisFirmasiHesabi',
      'hesapTuru',
      'hesapNo',
      'iban',
      'acilisTarihi',
      'kapanisTarihi',
      'sonIslemTarihi',
      'bakiyeTP',
      'bakiye',
      'paraBirimi',
      'kisitlamaTuru',
      'kisitlamaDigerAciklama',
      'hesapSahibi',
      'magdur',
      'adSoyadUnvan',
      'tckn',
      'vkn',
      'ykn',
      'passaport',
      'supheKategorisi',
      'bildirimAciklama',
      'gercekKisi',
      'islemleBaglantisi',
      'islemleBaglantisiAciklama',
      'adi',
      'soyadi',
      'tckn',
      'vkn',
      'ykn',
      'dogumTarihi',
      'dogumYeri',
      'anaAdi',
      'babaAdi',
      'uyrugu',
      'cinsiyeti',
      'kimlikBelgesi',
      'belgeTuru',
      'belgeNumarasi',
      'gecerlilikTarihi',
      'meslek',
      'ekBilgi',
      'adres',
      'adresSatir',
      'postaKodu',
      'ilKodu',
      'ilceKodu',
      'ulkeKodu',
      'iletisimBilgisi',
      'kimlikBilgileriSahte',
      'magdur',
      'kimlikTespitTuruTip',
      'digerKisi',
      'islemleBaglantisi',
      'islemleBaglantisiAciklama',
      'kurulusNevi',
      'unvan',
      'isletmeAdi',
      'vkn',
      'sicilNo',
      'faaliyetKonusu',
      'ulkeKodu',
      'ilKodu',
      'ilceKodu',
      'kurulusTarihi',
      'websitesi',
      'ekBilgi',
      'adres',
      'adresSatir',
      'postaKodu',
      'ilKodu',
      'ilceKodu',
      'ulkeKodu',
      'iletisimBilgisi',
      'kimlikBilgileriSahte',
      'magdur',
    ];
    if (priorityOrder.includes(a) && priorityOrder.includes(b)) {
      return priorityOrder.indexOf(a) - priorityOrder.indexOf(b);
    } else if (priorityOrder.includes(a)) {
      return -1;
    } else if (priorityOrder.includes(b)) {
      return 1;
    } else {
      return a.localeCompare(b);
    }
  };
}

interface Props extends ReduxProps { }

const mapStateToProps = (state: RootState) => ({
  page: state.page,
  configuration: state.configuration as ConfigurationState,
});

const mapDispatchToProps = {
  changeConfiguration,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

class State {
  transaction: TransactionJsonModel | undefined;
}

export default connector(DomainConfigurationSuspiciousActivityReportComponent);
